import FrontLayout from "../../../components/layout-new-theme/FrontLayout";
import NotificationDetail from "../my-page/_components/notification/NotificationDetail";

const NotificationDetailPage = () => {
  return (
    <FrontLayout>
      <div className="bg-page">
        <div className="tw:w-full tw:mx-auto tw:[--gx:1.5rem] tw:px-[calc(var(--gx)/2)] tw:mt-1 tw:pt-1">
          <div className="custom-mx">
            <div className="tw:w-full tw:mx-auto tw:[--gx:1.5rem] tw:px-[calc(var(--gx)/2)] tw:sm:max-w-[540px] tw:md:max-w-[720px] tw:lg:max-w-[960px] tw:xl:max-w-[1140px] tw:2xl:max-w-[1320px] tw:pb-12 tw:!mt-8 tw:lg:w-full tw:lg:flex-none">
              <h2>Notifications</h2>
              <hr className="divider"/>
              <NotificationDetail />
            </div>
          </div>
        </div>
      </div>
    </FrontLayout>
  );
};

export default NotificationDetailPage;
